import React, { useState, useEffect, useRef } from "react";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import strings from "../../../../utils/strings";
import Icons from "../../../../Assets/Icons";
import "./CreateConsumableList.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetGetAllGroups, resetCreateConsumable, resetCreateGroup } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableSlice";
import { getAllGroups, createConsumable, createGroup } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableThunk";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import useValidation from "../../../../utils/validators";

const CreateConsumableList = () => {
  const { t } = useTranslation();
  const { getAllGroupErr, getAllGroupSuccess, createConsumableSuccess, createConsumableErr, createGroupSuccess, createGroupErr } = useSelector((state) => state.addConsumable);
  const { validateCreateConsumable } = useValidation();
  const dispatch = useDispatch();
  const nav = useNavigate();
  const location = useLocation();
  const breadcrumbs = ["nursingCare", "manageResource", "additionalConsumables"];
  const [inputModal, setInputModal] = useState(false);
  const [itemName, setItemName] = useState("");
  const [code, setCode] = useState("");
  const [numPcs, setNumPcs] = useState("");
  const [opdInternational, setOpdInternational] = useState("");
  const [opdLocal, setOpdLocal] = useState("");
  const [opdSubsidized, setOpdSubsidized] = useState("");
  const [selectedUOM, setSelectedUOM] = useState({ value: "", label: "" });
  const modalRef = useRef(null);
  const paths = [strings.navigation.manageNurseReq, strings.navigation.additionalConsumableList, location.pathname];
  const options = [
    { value: "PCS", label: t("PCS") },
    { value: "PAIR", label: t("Pair") },
    { value: "PACK", label: t("Pack") },
  ];
  const [groups, setGroups] = useState([]);
  const [selectedGrp, setSelectedGrp] = useState({});
  useEffect(() => {
    if (getAllGroupErr) {
      ToastPopup.error(getAllGroupErr);
    }
    if (getAllGroupSuccess && getAllGroupSuccess.status === "success") {
      const newGrp = getAllGroupSuccess.data.groups.map((item) => ({ value: item._id, label: item.group }));
      setGroups(newGrp);
    }
    dispatch(resetGetAllGroups());
  }, [getAllGroupSuccess, getAllGroupErr]);

  useEffect(() => {
    if (createConsumableErr) {
      ToastPopup.error(createConsumableErr);
    }
    if (createConsumableSuccess && createConsumableSuccess.status === "success") {
      nav(strings.navigation.additionalConsumableList);
      ToastPopup.success(t("consumableCreated", { name: createConsumableSuccess.data.consumable.code }));
    }
    dispatch(resetCreateConsumable());
  }, [createConsumableSuccess, createConsumableErr]);

  useEffect(() => {
    if (createGroupErr) {
      ToastPopup.error(createGroupErr);
    }
    if (createGroupSuccess && createGroupSuccess.status === "success") {
      ToastPopup.success(t("grpCreated", { name: createGroupSuccess.data.newGroup.group }));
      dispatch(getAllGroups());
    }
    dispatch(resetCreateGroup());
  }, [createGroupSuccess, createGroupErr]);

  useEffect(() => {
    dispatch(getAllGroups());
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        console.log("first");
        setInputModal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  const inputChange = (e) => {
    const { name, value } = e.target;
    if (name) {
      const setters = {
        itemName: setItemName,
        numPcs: setNumPcs,
        opdInternational: setOpdInternational,
        opdLocal: setOpdLocal,
        opdSubsidized: setOpdSubsidized,
        code: setCode,
      };

      if (["numPcs", "opdInternational", "opdLocal", "opdSubsidized"].includes(name)) {
        const noLeadingZero = value.replace(/^0+/, "");
        const formattedValue = noLeadingZero.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        setters[name](formattedValue);
      } else if (name === "code") {
        setters[name](value.toUpperCase().trimStart());
      } else {
        setters[name](value.trimStart());
      }
    }
  };

  const handleSave = () => {
    const body = {
      group: selectedGrp.value,
      code: code,
      itemName: itemName,
      stockUOM: selectedUOM.value,
      numberOfPcs: numPcs.replace(/,/g, ""),
      price: {
        opdInternationalPrice: opdInternational.replace(/,/g, ""),
        opdLocalPrice: opdLocal.replace(/,/g, ""),
        opdSubsidized: opdSubsidized.replace(/,/g, ""),
      },
      country: "6641f4beeb9fcc2db568c1f8",
    };
    if (validateCreateConsumable(body)) {
      dispatch(createConsumable({ body }));
    }
  };
  const handleCreateGroup = (e) => {
    setInputModal(false);
    dispatch(createGroup({ body: { group: e } }));
  };

  return (
    <div className="dp-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("additionalConsumables")}</div>
      <div className="cac-container">
        <div style={{ position: "relative" }}>
          <p className="cac-dropdown-label">
            {t("careGrpName")}
            <span className="asterik">*</span>
          </p>
          <Widgets.NewSelectDropdown options={groups} big placeholder={t("selGrpName")} onChange={(i) => setSelectedGrp(i)} selectedValue={selectedGrp} />
          <div ref={modalRef}>
            <p className="cac-create-underline" onClick={() => setInputModal(true)}>
              {t("createGrp")}
            </p>
            <Widgets.FloatingInput showModal={inputModal} handleCancel={() => setInputModal(false)} handleConfirm={handleCreateGroup} title={t("createGrp")} placeholder="entGrpName" />
          </div>
        </div>
        <div className="cac-body">
          <div className="cac-input-grid">
            <div className="cac-inputs pdl-hn">
              <label>
                {t("code")}
                <span className="asterik">*</span>
              </label>
              <input type="text" className="pdl-number" onChange={inputChange} placeholder={t("code")} name="code" value={code} />
            </div>
            <div className="cac-inputs pdl-hn">
              <label>
                {t("itemName")}
                <span className="asterik">*</span>
              </label>
              <input type="text" className="pdl-number" onChange={inputChange} placeholder={t("itemName")} value={itemName} name="itemName" />
            </div>
            <div className="cac-inputs pdl-hn">
              <label>
                {t("stockUOM")}
                <span className="asterik">*</span>
              </label>
              <div className="cac-sel-dropdown">
                <Widgets.NewSelectDropdown options={options} big placeholder={t("entStockUom")} noMargin selectedValue={selectedUOM} onChange={(i) => setSelectedUOM(i)} />
              </div>
            </div>
            <div className="cac-inputs pdl-hn">
              <label>
                {t("noOfPieces")}
                <span className="asterik">*</span>
              </label>
              <input type="text" className="pdl-number" onChange={inputChange} placeholder={t("noOfPieces")} value={numPcs} name="numPcs" />
            </div>
          </div>
          <div className="cac-price-box">
            <section className="cac-title-hr">
              <p className="cac-price-title">Price</p>
              <p className="cac-price-hr"></p>
            </section>
            <div className="dp-price-opd">
              <div className="dp-boxes cac-opd-box">
                <p>{t("opdInterInsured")}</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" onChange={inputChange} value={opdInternational} name="opdInternational" />
                </div>
              </div>
              <div className="dp-boxes cac-opd-box">
                <p>{t("opdLocalInsured")}</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" onChange={inputChange} value={opdLocal} name="opdLocal" />
                </div>
              </div>
              <div className="dp-boxes cac-opd-box">
                <p>{t("opdSubsidized")}</p>
                <div>
                  <span>₫</span>
                  <input type="text" placeholder="0" onChange={inputChange} value={opdSubsidized} name="opdSubsidized" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="save-speciality cac-save">
          <div className="speciality-cancel" onClick={() => nav(strings.navigation.additionalConsumableList)}>
            {t("cancel")}
          </div>
          <div className="speciality-save" onClick={handleSave}>
            {t("save")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateConsumableList;
